<section *ngIf="settings" class="mat-typography chat-form" [class.hidden]="formTag === null">
    <app-form-header [form]="settings.form" [displaySetting]="settings.displaySetting"></app-form-header>
    <div *ngIf="!isBrowserSupported" class="chat-form-browser-unsupported">
      <h4>{{ resources.UserBrowserNotSupported }}</h4>
    </div>
    <div class="form-body">
        <div *ngIf="error" class="form-error">
            <div class="error-icon uwf-warning"></div>
            <div class="error-msg">{{error}}</div>
        </div>
        <div class="form-content">
            <h4 *ngIf="settings.form.headerFooters[0].welcomeMessage; let welcomeMessage" [style.font-family]="settings.displaySetting.Font">{{ welcomeMessage }}</h4>
            <app-form [settings]="settings"
                      [language]="language"
                      [timezone]="timezone"
                      [reCaptchaEnabled]="reCaptchaEnabled"
                      [reCaptchaSiteKey]="reCaptchaSiteKey"></app-form>
        </div>
        <app-form-footer *ngIf="reCaptchaEnabled && isBrowserSupported" text="reCAPTCHA" [displaySetting]="settings.displaySetting"></app-form-footer>
        <app-form-footer *ngIf="settings.form.headerFooters[0].footer; let footerText" [text]="footerText" [displaySetting]="settings.displaySetting"></app-form-footer>
    </div>
</section>
